import {
  load as loadBase,
  init as initBase,
  measureTemperatureByThermalData as measureTemperatureByThermalDataBase,
  detectBlackBodyByThermalData as detectBlackBodyByThermalDataBase,
} from './temperatureDetectionWorkerBase';

export default class TemperatureMeasurementFakeWorker {
  private faceModel: any;
  private bbCoordinates: any;

  public async load() {
    await loadBase();

    this.importScript('/opencv.js');
  }

  public async init(data: any) {
    this.faceModel = await initBase(data);
  }

  public async measureTemperatureByThermalData(data: any) {
    if (!this.bbCoordinates) {
      this.bbCoordinates = await detectBlackBodyByThermalDataBase(data);
    }

    data.bbCoordinates = this.bbCoordinates;
    return measureTemperatureByThermalDataBase(data, this.faceModel);
  }

  private importScript(resourceUrl: string) {
    // eslint-disable-next-line
    // @ts-ignore
    if (!window.opencvjsimported) {
      const script = document.createElement('script');
      script.src = resourceUrl;
      script.async = false;
      document.body.appendChild(script);
      // eslint-disable-next-line
      // @ts-ignore
      window.opencvjsimported = true;
    }
  }
}
